import { apihubGet, apihubPost, apihubUpload } from "./apihub";
import { withQuery } from "./paths";

/** POST `/getInteractedCustomerDetail/create-template` */
export function createTemplate(payload = {}, sampleFile) {
  if (!sampleFile) {
    return apihubPost("/getInteractedCustomerDetail/create-template", payload);
  }
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (typeof value === "object") {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, String(value));
    }
  });
  formData.append("sampleMedia", sampleFile);
  return apihubUpload("/getInteractedCustomerDetail/create-template", formData);
}

/** GET `/getInteractedCustomerDetail/message-template-library` */
export function listMessageTemplateLibrary(query = {}) {
  return apihubGet(
    withQuery("/getInteractedCustomerDetail/message-template-library", query),
  );
}

/** POST `/getInteractedCustomerDetail/message-template-library/sync` */
export function syncMessageTemplateLibrary(payload = {}) {
  return apihubPost("/getInteractedCustomerDetail/message-template-library/sync", payload);
}
